<script setup lang="ts">
import { computed, useTemplateRef } from 'vue';
import { useI18n } from 'vue-i18n';
// biome-ignore lint/correctness/noUnusedImports: used via tag <KioskLayout> in <template>
import KioskLayout from '@/app/layouts/kiosk/KioskLayout.vue';
import { store } from '@/app/store';
// biome-ignore lint/style/useImportType: component is rendered in <template>
import GDPRConsentPanel from './gdpr-consent/GDPRConsentPanel.vue';
import { useGdprConsentFlow } from './gdpr-consent/useGdprConsentFlow';

const { t } = useI18n();
const consentPanel =
  useTemplateRef<InstanceType<typeof GDPRConsentPanel>>('consentPanel');

// biome-ignore lint/correctness/noUnusedVariables: used in <template>
const consentText = computed(() => {
  const locale = store.currentLocale?.code;
  const policyContent = store.kiosk?.policy_content;
  const localizedText = locale
    ? policyContent?.[locale]?.popup_text
    : undefined;

  return (
    localizedText ||
    policyContent?.en?.popup_text ||
    t('GDPRConsent.consentText')
  );
});

// biome-ignore lint/correctness/noUnusedVariables: used in <template>
const consentFlow = useGdprConsentFlow({
  pulseConsentButton: () => consentPanel.value?.pulseConsentButton(),
});
</script>

<template>
  <KioskLayout :classes="{ content: 'GDPRConsent' }" :is-centered="true">
    <GDPRConsentPanel
      ref="consentPanel"
      :action-taken="consentFlow.actionTaken.value"
      :consent-label="t('GDPRConsent.buttonConsent')"
      :consent-text="consentText"
      :decline-label="t('GDPRConsent.buttonDecline')"
      :privacy-policy-label="t('GDPRConsent.privacyPolicyLink')"
      :title="t('GDPRConsent.title')"
      @consent="consentFlow.onConsent"
      @decline="consentFlow.onDecline"
      @open-privacy-policy="consentFlow.onPrivacyPolicyClick"
    />
  </KioskLayout>
</template>
